import React from 'react';
import Themeitem from './Themeitem';

const Theme = () => {
  return (
    <Themeitem />
  )
}

export default Theme;